import React, { Suspense } from 'react'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components';
import RollupKRComp from './rollup.component'
import KrTypeComp from './krtype.component'
import KpiTypeComp from './kpi_type.component'
import { autoResizeTextArea } from '../../../../utils/common'
import {
  TextareaFieldComp,
  ErrorTextComp,
} from '../../../inputs/fields.component'
import PersonComp from './person.component'
import MultipleIntervalTargetComp from './multipleIntervalTarget'
import KRStudioResults from './krstudio.component'
import WorkstreamComp from './workstream.component'
import GroupResultsComp from './group-result.component'
import GoalServices from '../../../../services/goal.services'
import CascadeKRComp from './cascade.component'
import CascadeKRComp2 from './cascade/cascadeKr'
// import NestedKrComp from "./nestedkr.component";
import MetricOwnerCommonModal from './metric-owner.component'
import { okrDetailConstants } from '../../../../constants/okr/okrDetails.constants'
import DropdownComp from '../../../dropdown/dropdown'
import LinkedKrComp from './linkedkr.component'
import { CoauthorButton, getCoauthorConfig } from '../coauthor';
import { MultipleKrCoOwnerSelect } from './MultipleKrCoOwnerSelect'
import { Button } from '@workboard/wobo-ui'
import { DurationSelect } from '../DurationSelect'
import { resolveDurationSelectInitial, resolveKrDuration } from '../goalPeriodRows'
import { isAnnualMitOkr } from './multipleIntervalTarget/mitDateSegments'
import { MIT_TYPE, QUARTER_TARGET_TYPE } from './multipleIntervalTarget/mitConstants'
import { previewKrName } from '../../../../utils/krNamePreview.util'
import { isKeyResultClosed } from '../../../../utils/closeKeyResult.util'

const AnnualMITKRTypeComp = React.lazy(() =>
  import(
    /* webpackChunkName: "mit-target-types" */
    './multipleIntervalTarget/mit-target-types'
  )
)

const TextareaContainer = styled('div')({
  position: 'relative',
  [`& ${CoauthorButton}`]: {
    position: 'absolute',
    right: 4,
    bottom: 24
  }
})

const MIT_SOURCES = ["12", "13", 12, 13];
class MetricComp extends React.Component {
  constructor(props) {
    super(props)
    const isAnnual = isAnnualMitOkr(this.props.goalDetails)
    const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
    // item start/end dates are in seconds as string (unix timestamp)
    // goal start/end dates are in formatted date string (MMM DD, YYYY) ex: Jan 01, 2025
    const metricStartDateValue = props.item?.start_date ?
      moment.unix(props.item?.start_date).utc().format("MM/DD/YYYY") :
      moment.utc(props.goalDetails.start_date).format("MM/DD/YYYY");
    const metricEndDateValue = props.item?.end_date ?
      moment.unix(props.item?.end_date).utc().format("MM/DD/YYYY") :
      moment.utc(props.goalDetails.target_date).format("MM/DD/YYYY");

    const initialKrDuration = resolveKrDuration(
      props.item,
      props.goalDetails,
      ''
    );

    this.state = {
      krText: !this.props.mitChildKr
        ? this.props.isChildKr
          ? this.props.basicInlineData && this.props.basicInlineData.name
            ? this.props.basicInlineData.name
            : this.props.item && this.props.item.name
            ? this.props.item.name
            : ''
          : this.props.krTextForWS
          ? this.props.krTextForWS
          : this.props.item && this.props.item.name
          ? this.props.item.name
          : this.props.addKrValue
        : this.props.item.name,
      krNote:
        this.props.item && this.props.item.description
          ? this.props.item.description
          : '',
      kpiType: this.props.kpiType || '',
      lastSourceType:
        this.props.item && this.props.item.source ? this.props.item.source : '',
      errors: this.props.errors || {},
      owner: {
        id:
          this.props.item && this.props.item.owner
            ? this.props.item.owner
            : null,
        name:
          this.props.item && this.props.item.owner_fullname
            ? this.props.item.owner_fullname
            : null,
        avatar:
          this.props.item && this.props.item.owner_pic
            ? this.props.item.owner_pic
            : null,
        email:
          this.props.item && this.props.item.owner_email
            ? this.props.item.owner_email
            : null,
      },
      realOwner: {
        id:
          (this.props.item && this.props.item.real_owner && this.props.mitChildKr)
            ? this.props.item.real_owner.id
            : (this.props.item && this.props.item.real_owner)
            ? this.props.item.real_owner
            : this.props.basicInlineData && this.props.basicInlineData.owner
            ? this.props.basicInlineData.owner
            : this.props.goalDetails.owner_id,
        name:
          (this.props.item && this.props.item.real_owner && this.props.mitChildKr)
            ? this.props.item.real_owner.name
            : (this.props.item && this.props.item.real_owner_fullname)
            ? this.props.item.real_owner_fullname
            : this.props.basicInlineData && this.props.basicInlineData.ownerName
            ? this.props.basicInlineData.ownerName
            : this.props.goalDetails.owner_fullname,
        avatar:
          (this.props.item && this.props.item.real_owner && this.props.mitChildKr)
            ? this.props.item.real_owner.avatar
            : (this.props.item && this.props.item.real_owner_pic)
            ? this.props.item.real_owner_pic
            : this.props.basicInlineData && this.props.basicInlineData.ownerPic
            ? this.props.basicInlineData.ownerPic
            : this.props.goalDetails.owner_pic,
      },
      confirmPopup: false,
      clusterData: [],
      selectedType:
        Object.keys(QUARTER_TARGET_TYPE)
          .filter(
            (k) => QUARTER_TARGET_TYPE[k] == this.props.item.quarter_target_type
          )
          .toString() ||
        (isAnnual && this.props.krType === 'multipleIntervalTargets'
          ? MIT_TYPE.ADD_UP
          : ''),
      permissionHelpPopUp: false,
      mitTypeError: false,
      // nested_krs: this.props.item && this.props.item.nested_krs ? this.props.item.nested_krs : null,
      // child_kr_duration: this.props.isChildKr
      // ? this.props.item && this.props.item.startDateText
      // ? this.props.goalDetails.metricQuarterOption.find((opt) => (opt.start == this.props.item.startDateText && opt.end == this.props.item.endDateText))
      // : this.props.basicInlineData && this.props.basicInlineData.duration
      // ? this.props.basicInlineData.duration
      // : this.props.goalDetails.metricQuarterOption[0]
      // : null,
      isAnnualMit: isAnnual,
      krExtractInitialValue: '',
      krExtractTargetValue: '',
      krExtractValueType: '',
      krExtractDirectionValue: '',
      krExtractName: '',
      selectednlplTags:this.props.selectednlplTags,
      selectednlplTagsName:this.props.selectednlplTagsName,
      tagsList:this.props.tagsList,
      nplTags:this.propsnplTags,
      krTypeMIT: (this.props.item && this.props.item.source && MIT_SOURCES.includes(this.props.item.source)) ? (this.props.item.source == "12" ? "person" : "ds") : "person",
      metricStartDateValue,
      metricEndDateValue,
      kr_duration: initialKrDuration || '',
      kr_durationOption: this.props.goalDetails.annualQuarterOption
      ? this.props.goalDetails.annualQuarterOption
      : '',
      isQuarter: initialKrDuration?.isQuarter ?? false,
      DropdownOption:  [],
      DropDownMetridId:'',
      dropDownValueChangedValue:false,
      coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwnersDetails && this.props.item.coOwnersDetails.length > 0 ? this.props.item.coOwnersDetails:  (this.props.item.coOwners && Array.isArray(this.props.item.coOwners) && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && Array.isArray(this.props.coOwners) && this.props.coOwners.length > 0 ? this.props.coOwners : []))): [],
      enableCoOwner: isKrCoOwnerEnabled && this.props.item.coOwners && this.props.item.coOwners.length > 0 ? true : false,
    }

    this.GoalServices = new GoalServices()

    this.changeMetricName = this.changeMetricName.bind(this)
    this.predictValues = this.predictValues.bind(this)
    this.metricNameEnter = this.metricNameEnter.bind(this)
    this.saveMetricData = this.saveMetricData.bind(this)
    this.updateClusterData = this.updateClusterData.bind(this)
    this.showMetricNameErr = this.showMetricNameErr.bind(this)
    this.RollupKRComp = React.createRef()
    this.CascadeKRComp = React.createRef()
    this.GroupResultsComp = React.createRef()
    this.changeMetricNote = this.changeMetricNote.bind(this)
    this.updateClusterData = this.updateClusterData.bind(this)
    this.changeRadio = this.changeRadio.bind(this)
    this.setSavedAnnualDuration = this.setSavedAnnualDuration.bind(this)
    this.changeMetricDurationVal= this.changeMetricDurationVal.bind(this)
    this.dropDownValueChanged = this.dropDownValueChanged.bind(this)
    this.coauthorNode = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    let newState = {
      ...state,
    }

    // WS KRs use WB Worker as owner.  Ensure we default back to current user if switching from WS KR.
    const useMITChildRealOwner = (props.mitChildKr
      && (
        // will have old source value
        props.item?.source == 2 ||
        props.item?.source == 3
      )
      && props.krType != 'workstream'
      && String(props.item?.owner).toUpperCase() == 'WB')
      ?? false

    if (state.owner.email === okrDetailConstants.WB_WORKER_EMAIL || useMITChildRealOwner) {
      newState.owner = {
        id: state.realOwner.id,
        name: state.realOwner.name,
        avatar: state.realOwner.avatar,
      }
    }

    const isAnnualMit = isAnnualMitOkr(props.goalDetails)
    if (isAnnualMit !== state.isAnnualMit) {
      newState.isAnnualMit = isAnnualMit
    }
    // if(state.nested_krs && state.nested_krs.length > 0 && !state.nested_krs[0].duration){
    // let gDetails = props.goalDetails;
    // let newNestedKrs = state.nested_krs.map((kr) => {
    // // let { startDateText, endDateText, ...krData } = kr;
    // return {
    // ...kr,
    // duration: gDetails.metricQuarterOption.find((opt) => (opt.start == kr.startDateText && opt.end == kr.endDateText))
    // }
    // });
    // newState.nested_krs = newNestedKrs;
    // }
    return newState
  }

  // shouldComponentUpdate(nextProps, nextState){
  // if(!this.props.isNestedKrTitle && nextProps.isNestedKrTitle ){
  // return false;
  // }
  // return true;
  // }
  componentWillUnmount() {
    this.props.comboMetricRef(null)
    window.removeEventListener('coauthorSaveKeyResult', this.handleCoauthorSaveKeyResult);
    // closing the editor (any path) drops the preview; a save's refetch then shows the stored name
    if (this.props.item?.id) previewKrName(this.props.item.id, null)
  }

  componentDidMount() {
    this.props.comboMetricRef(this)

    setTimeout(() => {
      const deleteButton = document.getElementById("set-delete-focus");
      if (deleteButton) {
        deleteButton.focus();
      }
    });
    if (this.props.krType != 'mirrorkr') {
      if (
        this.firstTextArea &&
        this.firstTextArea.refs &&
        this.firstTextArea.refs.textAreaMetric &&
        this.firstTextArea.refs.textAreaMetric.value.length > 80
      ) {
        autoResizeTextArea(this.firstTextArea.refs.textAreaMetric)
      }
      //this.secondTextArea.refs.noteAreaMetric.value.length > 80 &&
      //autoResizeTextArea(this.secondTextArea.refs.noteAreaMetric);
      let goal = this.props.goalDetails
      this.GoalServices.searchRollupOkrs({
        type: 'kr',
        goal_start: goal.start_date,
        goal_end: goal.target_date,
      })
      this.GoalServices.searchRollupOkrs({ type: 'okr' })
      this.GoalServices.searchRollupOkrs({
        type: 'mirror_kr',
        goal_start: goal.start_date,
        goal_end: goal.target_date,
      })
      if (!this.props.item.clusterCount || this.props.item.clusterCount == 0) {
        if (
          this.props.addOkrData &&
          this.props.addOkrData.display_kr_clustering &&
          (this.props.item.name || this.props.addKrValue)
        ) {
          this.GoalServices.getClusterData({
            goalId: this.props.item.goal_id
              ? this.props.item.goal_id
              : this.props.goalDetails.id,
            metricId: this.props.item.id ? this.props.item.id : 0,
            text: this.props.item.name
              ? this.props.item.name
              : this.props.addKrValue,
          }).then((response) => {
            if (response.status === 200) {
              this.setState({
                clusterData:
                  response.data.data.metrics[this.props.item.id || 0]['cKR'],
              })
            }
          })
        }
      } else {
        this.setState({ clusterData: this.props.item.clusterItems })
      }
    } else {
      let goal = this.props.goalDetails
      this.GoalServices.searchRollupOkrs({
        type: 'mirror_kr',
        goal_start: goal.start_date,
        goal_end: goal.target_date,
      })
    }
    if(this.props.isChildKr){
      setTimeout(()=>{
          document.getElementById("set-arrowbtn-focus").focus()
          })
    }

    window.addEventListener('coauthorSaveKeyResult', this.handleCoauthorSaveKeyResult);

  }

  handleCoauthorSaveKeyResult = (e) => {
    const { value, originatorId } = e.detail;
    if (originatorId !== this.metricNameTextareaId) return;
    this.changeMetricName({ target: { value }});
  }

  clickButtonEvent = item => {
    this.setState({krTypeMIT: item.id, errors: {}});
  };

  updateClusterData(resp) {
    this.setState({ clusterData: resp })
  }
  onChange = (e, key, val) => {
    this.setState({ [key]: val })
  }

  changeMetricName(e) {
    autoResizeTextArea(document.getElementById('metric-name-text'))
    if ($('#metric-name-text').val().trim() != '') {
      document.getElementById('krNameError').innerHTML = ''
    }
    this.setState({ krText: e.target.value, errors: {} })
    if (this.props.item?.id) {
      // don't write the KR title's DOM directly: it detaches React's text nodes
      previewKrName(this.props.item.id, e.target.value, this.props.item.name)
    }
  }

  changeMetricNote(e, data) {
    // autoResizeTextArea(document.getElementById('metric-name-note'))
    if (this.state.errors['krText'] === '') {
      // document.getElementById("krNameError").innerHTML = "";
      this.showMetricNameErr(false)
    }
    this.setState({ krNote: data, errors: {} })
  }

  renderError(field) {
    return <ErrorTextComp errors={this.state.errors} field={field} />
  }

  showMetricNameErr(bool = true) {
    const { t } = this.props
    let errors = {}
    if (bool) {
      errors['krText'] = t('Enter the metric name.')
      this.setState({ errors })
      $('.krRightPaneContent').parent().animate({ scrollTop: 0 })
    } else {
      errors['krText'] = ''
      this.setState({ errors })
    }
  }

  showMetricOwnerErr() {
    const { t } = this.props
    let errors = {}
    errors['krOwner'] = t('Select the metric owner name.')
    this.setState({ errors })
    $('.krRightPaneContent').parent().animate({ scrollTop: 0 })
  }
  showRolErr = (bool) => {
    console.log('showRolErr called with:', bool);
    let errors = { ...this.state.errors }
    if (bool) {
      errors['real_owner_validation'] = `${this.props.item.real_owner_fullname} has Read Only access and can't be assigned KRs`;
      console.log('Setting error:', errors['real_owner_validation']);
      this.setState({ errors })
      $('.krRightPaneContent').parent().animate({ scrollTop: 0 })
    } else {
      delete errors['real_owner_validation'];
      console.log('Deleting error, errors object:', errors);
      this.setState({ errors })
    }
  }
  dropDownValueChanged(Value){

    this.setState({
      dropDownValueChangedValue : Value
    })

  }
  setSavedAnnualDuration(is_Quarter, quarterName, metricId) {
    if (!metricId) {
      return;
    }

    const item = {
      ...(this.props.item || {}),
      startDateText: this.state.metricStartDateValue,
      endDateText: this.state.metricEndDateValue,
    };
    const krDuration = resolveKrDuration(item, this.props.goalDetails, this.state.kr_duration);
    if (!krDuration?.start) {
      return;
    }

    this.setState({
      kr_duration: krDuration,
      isQuarter: krDuration.isQuarter,
      DropDownMetridId: metricId,
    });
  }
  changeMetricDurationVal(from, data, text) {
    this.setState({
      kr_duration:{
        start:data.start,
        end:data.end,
        name:data.name,
        year:data.year,
        value:data.value,
        qname: data.quarter_name,
        isQuarter:data.isQuarter,
        isCustom: !data.year && data.value === undefined,
      },
     })
    this.setState({isQuarter: data.isQuarter})
    this.GoalServices.krAnnualDropdownEventTracking({ref:"KRDURATION_EDIT",merticId:this.state.DropDownMetridId})
this.dropDownValueChanged(true)
  }
  saveMetricData() {
    let { krType, addEditFlag, lastType } = this.props
    const { t } = this.props
    let krText = this.state.krText.trim()
    let krNote = this.state.krNote.trim()
    let errors = {}
    if (krType == 'rollupokrs') {
      if (krText == '') {
        errors['krText'] = t('Enter the metric name.')
        this.setState({ errors })
        let elem = document.getElementById("metric-name-text");
        elem.setAttribute("aria-invalid", "true");
        setTimeout(() => {
          document.getElementById("metric-name-text").focus();
        });
      }
      if (this.RollupKRComp) {
        let isError = Object.keys(errors).length ? true : false
        this.RollupKRComp.current.saveRollUp(isError)
      }
    } else if (krType == 'survey') {
      if (krText == '') {
        errors['krText'] = t('Enter the metric name.')
        this.setState({ errors })
      }
      if (this.GroupResultsComp) {
        let isError = Object.keys(errors).length ? true : false
        this.GroupResultsComp.current.saveGroupResults(isError)
      }
    } else if (krType == 'cascade') {
      if (krText == '') {
        errors['krText'] = t('Enter the metric name.')
        this.setState({ errors })
      }
      if (this.CascadeKRComp) {
        let isError = Object.keys(errors).length ? true : false
        this.CascadeKRComp.current.saveCascadeResults(isError)
      }
    }
  }

  predictValues() {
    if (
      $('#metric-name-text').val().trim() !== '' &&
      !this.state.predicted &&
      !this.props.item.id &&
      this.props.krType === 'person'
    ) {
      this.GoalServices.getKRExtract({
        krName: $('#metric-name-text').val().trim(),
      }).then((response) => {
        if (
          response.status === 200 &&
          (response.data?.data?.InitialValue ||
            response.data?.data?.TargetValue)
        ) {
          this.setState({
            predicted: true,
            krExtractInitialValue: response.data?.data?.InitialValue,
            krExtractTargetValue: response.data?.data?.TargetValue,
            krExtractValueType: response.data?.data?.ValueType,
            krExtractDirectionValue: response.data?.data?.DirectionValue,
            krExtractName: $('#metric-name-text').val().trim(),
          })
        } else if (response.data.status !== 'fatal_error') {
          // If there is no prediction then we wanted to auto fill with 0, 100, %, increase
          // at the same time if for some reason we don't have API response we are not defaulting these
          this.setState({
            krExtractInitialValue: 0,
            krExtractTargetValue: 100,
            krExtractValueType: 3,
            krExtractDirectionValue: 1,
            predicted: false,
          })
        }
      })
    }
  }

  metricNameEnter(e) {
    if (e.keyCode === 13) {
      e.preventDefault()
    }
  }

  updateRealOwner = (data) => {
    this.setState({
      realOwner: {
        id: data.userId,
        name: data.userText,
        avatar: data.userPic,
      },
    })
  }
  updateCoOwner = (data) => {
    if (data.length > 0) {
      this.setState({
        coOwners: data,
      })
    } else {
      this.setState({
        coOwners: []
      })
    }
  }
  changeRadio(value) {
    const valueToSet = value;
    let krTypeMIT = value !== MIT_TYPE.TRACK_PROGRESSION ? 'person' : this.state.krTypeMIT;
    this.setState(
      {
        selectedType: valueToSet,
        mitTypeError: false,
        krTypeMIT: krTypeMIT,
      },
      () => {
        if (valueToSet === MIT_TYPE.SUPPORTING_QUARTER_KR) {
          this.props.addAnotherNestedKr(true, true, true)
          this.setState({ selectedType: '' })
          $('.krRightPaneContent').parent().animate({ scrollTop: 0 })
        }
      }
    )
  }

  handleCancel = () => {
    if (this.props.goBackFromMitNestedKr) {
      this.props.goBackFromMitNestedKr()
    } else {
      this.props.closeKrRightPane(
        false,
        this.props.item.id ? this.props.item.id : ''
      )
    }
  }

  metricNameTextareaId = "metric-name-text";
  handleCoauthorClick = (e) => {
    const { goal, metrics = [] } = this.props.goalDetails;
    const textarea = document.getElementById(this.metricNameTextareaId);
    window.openOkrCoauthor({
      type: "OPEN_KR_CHAT",
      initialDraft: this.state.krText,
      anchor: textarea,
      placement: 'bottom',
      config: getCoauthorConfig(this.props.goalDetails),
      originator: { id: this.metricNameTextareaId, type: "kr", krSlotIndex: -1 },
      initialDraftOKR: {
        objective: goal,
        keyResults: metrics.map(m => m.name)
      },
      width: textarea.clientWidth
    }, this.coauthorNode.current);
  }

  render() {
    let renderMetric = null
    let {
      krType,
      changeDataSourceOption,
      addEditFlag,
      t,
      addOkrData,
      kpiType,
      onShowDismissButtonChange,
    } = this.props
    const isClosedKr = isKeyResultClosed(this.props.item)

    // let textareaLabel = "What is the  " + t('result') + " you want to measure?";
    let textareaLabel = t('Where will the key result data come from?')
    let textareaProps = {
      id: this.metricNameTextareaId,
      name: 'metric',
      onChange: this.changeMetricName,
      onKeyDown: this.metricNameEnter,
      onBlur: this.predictValues,
      value: this.state.krText,
      disabled: isClosedKr,
      krextractinitialvalue: this.state.krExtractInitialValue,
      krextracttargetvalue: this.state.krExtractTargetValue,
      krextractvaluetype: this.state.krExtractValueType,
      krextractdirectionvalue: this.state.krExtractDirectionValue,
      krextractname: this.state.krExtractName,
      'data-kr-id': this.props.isChildKr ? 'metric-child-kr-name-text' : '',
    }
    let labelRightSide = ''
    if (wbConfig.default_org_locale == 'locale_1') {
      labelRightSide =
        `<a class="sample-okr-text" href="https://www.workboard.com/okrs-by-function/" target="_blank">${t('See sample')} ` +
        t('OKRs') +
        `</a>`
    }
    if (krType == 'rollupokrs') {
      renderMetric = (
        <RollupKRComp
          ref={this.RollupKRComp}
          {...this.props}
          krText={this.state.krText}
          kr_duration={this.state.kr_duration}
          dropDownValueChangedValue={this.state.dropDownValueChangedValue}
          dropDownValueChanged={this.dropDownValueChanged}
          setSavedAnnualDuration={this.setSavedAnnualDuration}
          isQuarter={this.state.isQuarter}
          krNote={this.state.krNote}
          addEditFlag={addEditFlag}
          realOwner={this.state.realOwner}
          changeDataSourceOption={changeDataSourceOption}
          t={t}
          clusterData={this.state.clusterData}
          goBackFromMitNestedKr={this.props.goBackFromMitNestedKr}
          coOwners={this.state.coOwners}
        />
      )
    } else if (krType == 'survey') {
      renderMetric = (
        <GroupResultsComp
          ref={this.GroupResultsComp}
          kr_duration={this.state.kr_duration}
          setSavedAnnualDuration={this.setSavedAnnualDuration}
          isQuarter={this.state.isQuarter}
          {...this.props}
          krText={this.state.krText}
          owner={this.state.owner}
          realOwner={this.state.realOwner}
          krNote={this.state.krNote}
          t={t}
          clusterData={this.state.clusterData}
          goBackFromMitNestedKr={this.props.goBackFromMitNestedKr}
          coOwners={this.state.coOwners}
        />
      )
    } else if (krType == 'cascade') {
      const props = {
        ref: this.CascadeKRComp,
        kr_duration: this.state.kr_duration,
        setSavedAnnualDuration: this.setSavedAnnualDuration,
        isQuarter: this.state.isQuarter,
        ...this.props,
        krText: this.state.krText,
        realOwner: this.state.realOwner,
        krNote: this.state.krNote,
        t,
        clusterData: this.state.clusterData,
        coOwners: this.state.coOwners,
        teamId: this.props.goalDetails.team_id,
      }
      if (window.wbConfig.isEnhancedCascadesEnabled) {
        renderMetric = (
          <CascadeKRComp2 {...props} onShowDismissButtonChange={onShowDismissButtonChange} />
        )
      } else {
        renderMetric = (
          <CascadeKRComp {...props} />
        )
      }
    } else if (krType == 'kpi') {
      renderMetric = (
        <KpiTypeComp
          {...this.props}
          showMetricNameErr={this.showMetricNameErr}
          showMetricOwnerErr={this.showMetricOwnerErr}
          kpiType={kpiType}
          selectedKpiData={this.props.selectedKpiData}
          kr_duration={this.state.kr_duration}
          setSavedAnnualDuration={this.setSavedAnnualDuration}
          isQuarter={this.state.isQuarter}
          krText={this.state.krText}
          krNote={this.state.krNote}
          owner={this.state.owner}
          realOwner={this.state.realOwner}
          addEditFlag={addEditFlag}
          goBackFromMitNestedKr={this.props.goBackFromMitNestedKr}
          lastSourceType={this.state.lastSourceType}
          coOwners={this.state.coOwners}
          showRolErr={this.showRolErr}
        />
      )
    } else if (krType == 'person') {
      renderMetric = (
        <PersonComp
          {...this.props}
          krText={this.state.krText}
          kr_duration={this.state.kr_duration}
          setSavedAnnualDuration={this.setSavedAnnualDuration}
          isQuarter={this.state.isQuarter}
          krNote={this.state.krNote}
          owner={this.state.owner}
          realOwner={this.state.realOwner}
          showMetricNameErr={this.showMetricNameErr}
          showMetricOwnerErr={this.showMetricOwnerErr}
          showRolErr={this.showRolErr}
          showRealOwner={this.props.showRealOwner}
          clusterData={this.state.clusterData}
          goBackFromMitNestedKr={this.props.goBackFromMitNestedKr}
          predicted={this.state.predicted}
          krExtractInitialValue={this.state.krExtractInitialValue}
          krExtractTargetValue={this.state.krExtractTargetValue}
          krExtractValueType={this.state.krExtractValueType}
          krExtractName={this.state.krExtractName}
          krExtractDirectionValue={this.state.krExtractDirectionValue}
          selectednlplTags={this.state.selectednlplTags}
          selectednlplTagsName={this.state.selectednlplTagsName}
          tagsList={this.state.tagsList}
          nplTags={this.state.nplTags}
          coOwners={this.state.coOwners}
        />
      )
    } else if (krType == 'krstudio') {
      renderMetric = (
        <KRStudioResults
          {...this.props}
          krText={this.state.krText}
          kr_duration={this.state.kr_duration}
          setSavedAnnualDuration={this.setSavedAnnualDuration}
          isQuarter={this.state.isQuarter}
          krNote={this.state.krNote}
          realOwner={this.state.realOwner}
          showMetricNameErr={this.showMetricNameErr}
          clusterData={this.state.clusterData}
          // updateNestedKrs = {this.updateNestedKrs}
          // nested_krs = {this.state.nested_krs}
          // childKrDuration = {this.state.child_kr_duration}
        />
      )
    } else if (krType == 'workstream') {
      renderMetric = (
        <WorkstreamComp
          {...this.props}
          saveNewWs={this.props.saveNewWs}
          kr_duration={this.state.kr_duration}
          setSavedAnnualDuration={this.setSavedAnnualDuration}
          isQuarter={this.state.isQuarter}
          krText={this.state.krText}
          krNote={this.state.krNote}
          owner={this.state.owner}
          realOwner={this.state.realOwner}
          showMetricNameErr={this.showMetricNameErr}
          showMetricOwnerErr={this.showMetricOwnerErr}
          clusterData={this.state.clusterData}
          goBackFromMitNestedKr={this.props.goBackFromMitNestedKr}
          coOwners={this.state.coOwners}
          showRolErr={this.showRolErr}
        />
      )
    } else if (krType === 'multipleIntervalTargets') {
      renderMetric = (
        <MultipleIntervalTargetComp
          {...this.props}
          realOwner={this.state.realOwner}
          kr_duration={this.state.kr_duration}
          setSavedAnnualDuration={this.setSavedAnnualDuration}
          isQuarter={this.state.isQuarter}
          owner={this.state.owner}
          showRealOwner={this.props.showRealOwner}
          clusterData={this.state.clusterData}
          isAnnualMit={this.state.isAnnualMit}
          mitType={this.state.selectedType}
          quarterTargetType={QUARTER_TARGET_TYPE}
          mitTypeError={this.state.mitTypeError}
          toggleMitTypeSelectError={(e) =>
            this.onChange(e, 'mitTypeError', !this.state.mitTypeError)
          }
          krText={this.state.krText}
          krNote={this.state.krNote}
          krTypeMIT={this.state.krTypeMIT}
          clickButtonEvent={this.clickButtonEvent}
          coOwners={this.state.coOwners}
          showRolErr={this.showRolErr}
        />
      )
    } else if (krType === 'mirrorkr') {
      renderMetric = (
        <LinkedKrComp
          key="linked_kr"
          changeDataSourceOption={this.props.changeDataSourceOption}
          {...this.props}
          krType={krType}
          MetricChangeWeight={this.props.MetricChangeWeight}
          addEditFlag={addEditFlag}
          lastType={this.props.lastType}
          updateNestedKrs={this.props.updateNestedKrs}
          nested_krs={this.props.nested_krs}
          childKrDuration={this.props.childKrDuration}
          updateChildKrDuration={this.props.updateChildKrDuration}
          coOwners={this.state.coOwners}
        />
      )
    }

    textareaLabel = t('What is your key result name?')
    if (wbConfig.default_org_locale == 'locale_1') {
      labelRightSide =
        `<a class="sample-okr-text" href="https://www.workboard.com/okrs-by-function/" target="_blank">${t('See sample')} ` +
        t('OKRs') +
        `</a>`
    }

    let noteareaLabel = t('Add description (optional)')
    let noteSecondLable = t('Description (optional)')
    let noteareaProps = {
      id: 'metric-name-note',
      name: 'metric-note',
      onChange: this.changeMetricNote,
      onKeyDown: this.metricNameEnter,
      value: this.state.krNote,
      disabled: isClosedKr,
    }
    let clusterFinalCount =
      this.props.item && this.props.item.clusterCount
        ? this.props.item.clusterCount
        : this.state.clusterData && this.state.clusterData.length
    let clusterFinalItems =
      this.props.item && this.props.item.clusterItems
        ? this.props.item.clusterItems
        : this.state.clusterData
    let clusterParams = {
      clusterCount: clusterFinalCount,
      clusterItems: clusterFinalItems,
      goal_id: this.props.goalDetails.id,
    }
    if (this.props.item && this.props.item.clusterItems) {
      clusterParams = this.props.item
    } else if (this.props.item && !this.props.item.clusterItems) {
      clusterParams = {
        ...clusterParams,
        ...this.props.item,
      }
    }
    let isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled;

    const durationSelectInitial = resolveDurationSelectInitial(
      this.props.item,
      this.props.goalDetails,
      this.state.kr_duration
    ) || {
      start: moment.utc(this.props.goalDetails.start_date).toISOString(),
      end: moment.utc(this.props.goalDetails.target_date).toISOString(),
    };

    return (
      <div
        className="metric-comp-wrapper width100 "
        style={{ marginBottom: this.props.isChildKr ? '150px' : '90px' }}
      >
        {krType !== 'mirrorkr' && (
        <>
        <TextareaContainer className="fieldcontent">
          <TextareaFieldComp
            ref={(ref) => (this.firstTextArea = ref)}
            textareaRef="textAreaMetric"
            label={textareaLabel}
            labelRightSide={labelRightSide}
            InputTypeFaceText="true"
            labelClass="metric-label-text"
            textareaProps={textareaProps}
            notelabel={false}
            displayKrClustering={addOkrData.display_kr_clustering}
            actions={this.props.actions}
            item={clusterParams}
            updateKRStates={this.props.updateKRStates}
            clusterData={this.state.clusterData}
            goal_id={this.props.goalDetails.id}
            basicInlineDataName={this.props.basicInlineData.name}
            updateClusterData={this.updateClusterData}
            onlyMetEdit={this.props.onlyMetEdit}
            isChildKr={this.props.isChildKr}
            childKrDuration={this.props.childKrDuration}
            saveNestedKRs={this.props.saveNestedKr}
            nestedKrIndex={this.props.nestedKrIndex}
            fromParentKr={
              this.props.fromParentKr ? this.props.fromParentKr : false
            }
            closeKrRightPanel={
              this.props.closeKrRightPane ? this.props.closeKrRightPane : ''
            }
            display_nested_kr={addOkrData.display_nested_kr}
            nested_krs={this.state.nested_krs}
          />
          <CoauthorButton variant="icon" onClick={this.handleCoauthorClick} size="large" disabled={isClosedKr} />
          {this.renderError('krText')}{' '}
        </TextareaContainer>
        <div ref={this.coauthorNode} />
        <div className="fieldcontent">
          <TextareaFieldComp
            ref={(ref) => (this.secondTextArea = ref)}
            textareaRef="noteAreaMetric"
            label={noteareaLabel}
            secondlabel={noteSecondLable}
            InputTypeFaceText="true"
            labelClass="metric-label-note"
            textareaProps={noteareaProps}
            notelabel={true}
            newLabelClass="metric-label-text"
          />
        </div>
        <div className="addEditKrPanelRow">
          {this.props.showRealOwner && (
            <div style={{display:'flex', flexDirection:'row'}}>
              <div>
              <div className="metricOwner" style={{marginTop: `${isKrCoOwnerEnabled ? '3px': ''}`}}>
                {t('Person responsible for business result')}
              </div>
              <MetricOwnerCommonModal
                mitChildKr={
                  this.props.mitChildKr ? this.props.mitChildKr : null
                }
                item={this.state.realOwner}
                addId="MetrictarttargetsecId"
                updateData={this.updateRealOwner}
                coOwners ={this.state.coOwners}
                teamId={this.props.goalDetails.team_id}
              />
              {this.renderError('krOwner')}
              {this.renderError('real_owner_validation')}

              </div>
            </div>

          )}
            {isKrCoOwnerEnabled && !this.state.enableCoOwner && <Button
            style={{marginLeft: "auto",marginTop: '30px', whiteSpace: 'break-spaces', height: 'auto'}}
            variant="secondary"
            isDisabled={isClosedKr}
            onClick={()=>
              {
                if (!this.state.enableCoOwner) {
                  this.setState({ enableCoOwner: true })
                } else{
                  this.setState({ enableCoOwner: false })
                }
              }
            }
            >
            <img  style={{marginRight: '4px'}} src={`${wbConfig.imageCdnUrl}/images/Group.svg`}/>
            {t('Add Co-owners')}
          </Button>}
        </div>
        <div style={{display:'flex', flexDirection:'row'}}>
            {this.state.enableCoOwner && <div>
              <div className="metricOwner">
                {t("Who's co-owning this result?")}
              </div>
              <MultipleKrCoOwnerSelect
              isMitChildKr={this.props.mitChildKr}
              realOwnerId={this.state.realOwner.id}
              coOwners ={this.state.coOwners}
              updateData={this.updateCoOwner}
              teamId={this.props.goalDetails.team_id}
              /> </div>}
              </div>
              {(this.props.isChildKr || this.props.mitChildKr) ?(
            <div
              style={{
                marginLeft: this.props.showRealOwner ? '10px' : 0,
                paddingLeft: `${isKrCoOwnerEnabled ? '16px' : ''}`
              }}
            >
              <div className="metricOwner" style={{margin:  `${isKrCoOwnerEnabled ? '5px' : ''}`}}>
                {t('Duration')}<span className="text-style-1">*</span>
              </div>
              {!this.props.mitChildKr ? (
                <DropdownComp //labelText="Show:"
                  wrapperClass="durationDropdown"
                  appendId="metric-duration"
                  defaultValue={
                    this.props.childKrDuration
                      ? this.props.childKrDuration.value
                      : 0
                  }
                  options={this.props.goalDetails.metricQuarterOption}
                  onChange={(e, item) => this.props.updateChildKrDuration(item)}
                />
              ) : (
                <div className="durationSupportingKR">
                  {
                    this.props.goalDetails.metricQuarterOption[
                      this.props.mitIndex % 4
                    ].name
                  }
                </div>
              )}
            </div>
          ):
          (
            this.state.kr_durationOption &&
            this.props.krType != 'multipleIntervalTargets' &&
            !this.props.isOwnerOfCascade &&
                <DurationSelect
                  style={{ marginTop: '16px' }}
                  isKr={true}
                  disabled={this.props.item?.canChangeDuration === false}
                  initialValue={durationSelectInitial}
                  onChange={(data) => {
                    this.changeMetricDurationVal('kr_duration', data)
                  }}
                  minAllowedDate={moment.utc(this.props.goalDetails.start_date).toISOString()}
                  maxAllowedDate={moment.utc(this.props.goalDetails.target_date).toISOString()}
                />
            )}
        </>
        )}
        <KrTypeComp
          showChangeOption={true}
          item={this.props.item}
          kpiType={this.props.kpiType || ''}
          krType={krType}
          changeDataSourceOption={changeDataSourceOption}
          addEditFlag={addEditFlag}
          isZenry={this.props.addOkrData.isZenryDomain}
          kr_ui_wizard={this.props.addOkrData.kr_ui_wizard}
          goalDetails={this.props.goalDetails}
          integrations={this.props.integrations}
          isChildKr={this.props.isChildKr}
          displayNestedKr={this.props.addOkrData.display_nested_kr}
          mitChildKr={this.props.mitChildKr}
          mitIndex={this.props.mitIndex}
          updateKRDataObject={this.props.updateKRDataObject}
        />
        <div
          className="krBreak"
          aria-hidden="true"
          style={{
            marginTop: '20px',
            marginBottom: '10px',
          }}
        />{' '}
        {krType === 'multipleIntervalTargets' && this.state.isAnnualMit && (
          <>
            <div className="kr-radio-text">
            {t('How will your quarterly targets contribute to annual progress') + '?*'}
            </div>
            {this.state.mitTypeError && (
              <div className="width100 krNameError">
                {t('Please select the quarterly targets')}
              </div>
            )}
            <Suspense fallback={null}>
              <AnnualMITKRTypeComp
                selectedType={this.state.selectedType}
                changeRadio={this.changeRadio}
                displayNestedKR={this.props.addOkrData.display_nested_kr}
                t={t}
              />
            </Suspense>
          </>
        )}
        {renderMetric}
      </div>
    )
  }
}

export default withTranslation()(MetricComp)
